require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__78815__) => {
return (globalThis["wpBaUiCarbonToolkit"] = globalThis["wpBaUiCarbonToolkit"] || []).push([[1198],{

/***/ 29684:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _utils = __webpack_require__(78815);
var _BaseInput = _interopRequireDefault(__webpack_require__(22052));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const {
  BaPropTypes
} = _utils.propsUtils;
const {
  uniqueId
} = _utils.lodash;
const {
  sanitize
} = _utils.propsUtils;
const {
  isKey,
  keyNames
} = _utils.keyboardUtils;
const {
  resolveBaseTextDir
} = _utils.bidiUtils;
const MESSAGE_TYPE_ERROR = 'error';
const MESSAGE_TYPE_WARNING = 'warning';
const MESSAGE_TYPE_INFORMATIONAL = 'informational';
const MESSAGE_TYPE_SUCCESS = 'success';
const _CLASS = _BaseInput.default.baseInputClassName.replace(/"/g, ''); // eslint-disable-line no-underscore-dangle

class BaseInput extends _react.Component {
  constructor(_props) {
    super(_props);
    (0, _defineProperty2.default)(this, "_useOnValueCallbacks", !!this.props.onValueChange || !!this.props.onValueAccept);
    (0, _defineProperty2.default)(this, "focus", () => {
      const {
        disabled
      } = this.props;
      !disabled && this.inputNode && this.inputNode.focus();
    });
    (0, _defineProperty2.default)(this, "select", () => {
      const {
        disabled
      } = this.props;
      !disabled && this.inputNode && this.inputNode.select();
    });
    (0, _defineProperty2.default)(this, "_onChange", e => {
      const {
        onChange
      } = this.props;
      const newValue = e.type === 'click' ? this.inputNode.value : e.target.value;
      this.setState({
        newValue
      });
      if (this._useOnValueCallbacks) {
        this._onValueChange(newValue);
        onChange && onChange(e);
        if (e.type === 'click') {
          this._onValueAccept(newValue);
        }
      } else {
        // this really really needs to get done(switch to native onChange behaviour)
        onChange && onChange(newValue, false);
      }
    });
    (0, _defineProperty2.default)(this, "_onValueChange", newValue => {
      const {
        onValueChange
      } = this.props;
      onValueChange && onValueChange(newValue);
    });
    (0, _defineProperty2.default)(this, "_onKeyUp", e => {
      const {
        type,
        onKeyUp
      } = this.props;
      const {
        value: newValue
      } = e.target;
      this.setState({
        newValue
      });
      if (type !== 'password' && isKey(e, keyNames.ENTER) || type === 'number' && (isKey(e, keyNames.UP /* 38 */) || isKey(e, keyNames.DOWN /* 40 */))) {
        if (this._useOnValueCallbacks) {
          this._onValueAccept(newValue);
        }
      }
      onKeyUp && onKeyUp(e);
    });
    (0, _defineProperty2.default)(this, "_onBlur", e => {
      const {
        onBlur
      } = this.props;
      const {
        value: newValue
      } = e.target;
      if (this._useOnValueCallbacks) {
        this._onValueAccept(newValue);
      }
      onBlur && onBlur(e);
    });
    (0, _defineProperty2.default)(this, "_onValueAccept", newValue => {
      const {
        onValueAccept
      } = this.props;
      this.setState({
        newValue: null
      });
      // toolkit widgets that call BaseInput need to check if
      // newValue !== oldValue before calling their onValueAccept
      // DO NOT do the check here, each widget applies prop limit checks
      onValueAccept && onValueAccept(newValue);
    });
    (0, _defineProperty2.default)(this, "_ref", node => this.inputNode = node);
    (0, _defineProperty2.default)(this, "_autoComplete", this.props.autoComplete || 'off');
    (0, _defineProperty2.default)(this, "_id", uniqueId('ba-common-base-input'));
    (0, _defineProperty2.default)(this, "_inputToRender", props => this.props.inputToRender(props));
    (0, _defineProperty2.default)(this, "_messageType", () => {
      if (this.props.hasValidationError && this.props.validationErrorText) {
        return MESSAGE_TYPE_ERROR;
      }
      if (this.props.isMoreInfo && this.props.moreInfoText) {
        return MESSAGE_TYPE_INFORMATIONAL;
      }
      if (this.props.successText) {
        return MESSAGE_TYPE_SUCCESS;
      }
      return undefined;
    });
    (0, _defineProperty2.default)(this, "_messageNode", () => {
      const messageType = this._messageType();
      if (messageType === MESSAGE_TYPE_ERROR) {
        return this.props.validationErrorText;
      }
      if (messageType === MESSAGE_TYPE_INFORMATIONAL) {
        return this.props.moreInfoText;
      }
      if (messageType === MESSAGE_TYPE_SUCCESS) {
        return this.props.successText;
      }
      return undefined;
    });
    this.state = {
      newValue: null
    };
  }
  componentDidMount() {
    const {
      autoFocus,
      autoSelect,
      onChange
    } = this.props;
    autoFocus && this.focus();
    autoSelect && this.select();

    // eslint-disable-next-line react/prop-types
    if (onChange) {
      console.warn('Warning - consider using onValueChange/onValueAccept: the behaviour of onChange will change to the native event when onValueChange/onValueAccept becomes the default behaviour');
    }
  }
  componentWillReceiveProps(_ref) {
    let {
      value: newValue
    } = _ref;
    const {
      value: oldValue
    } = this.props;
    if (newValue !== oldValue) {
      this.setState({
        newValue: null
      });
    }
  }
  componentWillUnmount() {
    const {
      newValue
    } = this.state;
    if (newValue !== null) {
      if (this._useOnValueCallbacks) {
        this._onValueAccept(newValue);
      } else {
        // this really really needs to get done(switch to native onChange behaviour)
        this.props.onChange(newValue, true);
      }
    }
  }

  // eventually/hopefully onValueChange/onValueAccept will be the norm, and useOnValueCallbacks can be removed

  // eslint-disable-line react/prop-types

  render() {
    // extract props that are to be manipulated or not passed down
    const {
      // baseInput specific
      // inherited props
      value,
      className,
      children,
      fullWidth,
      title,
      textAlign,
      dir,
      textDir,
      type,
      hasValidationError,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      validationErrorText,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      successText,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      isMoreInfo,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      moreInfoText,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      onChange,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      moreInfoClickHandler,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      onValueChange,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      onValueAccept,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      disabled,
      light,
      readOnly,
      inputToRender,
      // eslint-disable-line @typescript-eslint/no-unused-vars
      style,
      // all the other props
      ...others
    } = this.props;
    const messageType = this._messageType();
    const classNames = (0, _utils.classnames)(_CLASS, {
      fullWidth,
      error: messageType === MESSAGE_TYPE_ERROR,
      warning: messageType === MESSAGE_TYPE_WARNING,
      informational: messageType === MESSAGE_TYPE_INFORMATIONAL,
      success: messageType === MESSAGE_TYPE_SUCCESS
    });
    const widgetProps = {
      'data-tid': `${this._ID}__input`,
      ...sanitize(others, null),
      value: type === 'password' ? undefined : value || '',
      onChange: this._onChange,
      onKeyUp: this._onKeyUp,
      onBlur: this._onBlur,
      autoComplete: this._autoComplete,
      type,
      ref: this._ref,
      dir: resolveBaseTextDir(value, textDir, false),
      disabled: disabled || readOnly,
      light,
      style: {
        ...style,
        ...(textAlign ? {
          textAlign
        } : {})
      },
      invalid: !!messageType,
      invalidText: this._messageNode()
    };
    return /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({}, dir ? {
      dir
    } : {}, {
      title: title,
      className: `${classNames} ${className}`
    }), this._inputToRender(widgetProps), children);
  }
}
exports["default"] = BaseInput;
(0, _defineProperty2.default)(BaseInput, "propTypes", {
  id: _propTypes.default.string,
  'data-tid': _propTypes.default.string,
  className: _propTypes.default.string,
  title: _propTypes.default.string,
  type: _propTypes.default.oneOf(['password', 'time', 'number']),
  textAlign: _propTypes.default.oneOf(['left', 'right', 'center']),
  textDir: _propTypes.default.oneOf(['', 'ltr', 'rtl', 'auto']),
  dir: _propTypes.default.oneOf(['ltr', 'rtl']),
  fullWidth: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  // Carbon light variant of the component
  light: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  children: _propTypes.default.node,
  onKeyUp: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  autoFocus: _propTypes.default.bool,
  autoSelect: _propTypes.default.bool,
  allowEmpty: _propTypes.default.bool,
  /** callback function, to render the specific type of input */
  inputToRender: _propTypes.default.func,
  /** callback function, to deal with input as it changes */
  onValueChange: _propTypes.default.func,
  /** callback function, to deal with input when it is final */
  onValueAccept: _propTypes.default.func,
  // deprecated - not supported or no equivalent in Carbon

  /** deprecated: not applicable to carbon */
  active: BaPropTypes.deprecated('deprecated: not applicable to carbon'),
  /** deprecated: not applicable to carbon */
  ariaLabelledBy: BaPropTypes.deprecated('deprecated: not applicable to carbon'),
  /** deprecated: not applicable to carbon */
  hover: BaPropTypes.deprecated('deprecated: not applicable to carbon'),
  /** deprecated: not applicable to carbon */
  icon: BaPropTypes.deprecated('deprecated: not applicable to carbon'),
  /** deprecated: not applicable to carbon */
  iconLeft: BaPropTypes.deprecated('deprecated: not applicable to carbon'),
  /** deprecated: not applicable to carbon */
  iconRight: BaPropTypes.deprecated('deprecated: not applicable to carbon'),
  /** deprecated: not applicable to carbon */
  noBottomBorder: BaPropTypes.deprecated('deprecated: not applicable to carbon'),
  /** deprecated: not applicable to carbon */
  style: BaPropTypes.deprecated('deprecated: not applicable to carbon'),
  // deprecated - supported in a different way

  /** deprecated: use onValueChange/onValueAccept to replace fireOnBlur/onChange/onBlur */
  fireOnBlur: BaPropTypes.deprecated('deprecated: use onValueChange/onValueAccept to replace fireOnBlur/onChange/onBlur'),
  /** deprecated: to be replaced/remapped when Carbon message handling is updated */
  hasValidationError: BaPropTypes.deprecated('deprecated: to be replaced/remapped when Carbon message handling is updated'),
  /** deprecated: to be replaced/remapped when Carbon message handling is updated */
  isMoreInfo: BaPropTypes.deprecated('deprecated: to be replaced/remapped when Carbon message handling is updated'),
  /** deprecated: to be replaced/remapped when Carbon message handling is updated */
  moreInfoClickHandler: BaPropTypes.deprecated('deprecated: to be replaced/remapped when Carbon message handling is updated'),
  /** deprecated: to be replaced/remapped when Carbon message handling is updated */
  moreInfoText: BaPropTypes.deprecated('deprecated: to be replaced/remapped when Carbon message handling is updated'),
  /** deprecated: to be replaced/remapped when Carbon message handling is updated */
  successText: BaPropTypes.deprecated('deprecated: to be replaced/remapped when Carbon message handling is updated'),
  /** deprecated: to be replaced/remapped when Carbon message handling is updated */
  validationErrorText: BaPropTypes.deprecated('deprecated: to be replaced/remapped when Carbon message handling is updated'),
  /** deprecated: use disabled */
  readOnly: BaPropTypes.deprecated('deprecated: use disabled')
});
(0, _defineProperty2.default)(BaseInput, "defaultProps", {
  className: ''
});

/***/ }),

/***/ 79461:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
var _BaseInput = _interopRequireDefault(__webpack_require__(29684));
exports["default"] = _BaseInput.default;
exports.BaseInput = _BaseInput.default;

/***/ }),

/***/ 32705:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".ba-common-baseInput{position:relative;display:inline-block}.ba-common-baseInput.is-fullWidth{display:block;width:100%}.ba-common-baseInput.is-fullWidth .bx--number--helpertext{width:100%}.ba-common-baseInput.is-error .bx--text-input__field-wrapper[data-invalid]{outline-color:red}.ba-common-baseInput.is-error .bx--text-input__invalid-icon{fill:red}.ba-common-baseInput.is-error .bx--form-requirement{color:red}.ba-common-baseInput.is-warning .bx--text-input__field-wrapper[data-invalid]{outline-color:peru}.ba-common-baseInput.is-warning .bx--text-input__invalid-icon{fill:peru}.ba-common-baseInput.is-warning .bx--form-requirement{color:peru}.ba-common-baseInput.is-informational .bx--text-input__field-wrapper[data-invalid]{outline-color:#add8e6}.ba-common-baseInput.is-informational .bx--text-input__invalid-icon{fill:#add8e6}.ba-common-baseInput.is-informational .bx--form-requirement{color:#add8e6}.ba-common-baseInput.is-success .bx--text-input__field-wrapper[data-invalid]{outline-color:green}.ba-common-baseInput.is-success .bx--text-input__invalid-icon{fill:green}.ba-common-baseInput.is-success .bx--form-requirement{color:green}", ""]);

// exports
exports.locals = {
	"baseInputClassName": "\"ba-common-baseInput\""
};

/***/ }),

/***/ 22052:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_BaseInput_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32705);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_BaseInput_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_BaseInput_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_BaseInput_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_BaseInput_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_BaseInput_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_BaseInput_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_BaseInput_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_BaseInput_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 93379:
/***/ ((module) => {

"use strict";


var stylesInDOM = [];
function getIndexByIdentifier(identifier) {
  var result = -1;
  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }
  return result;
}
function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };
    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }
    identifiers.push(identifier);
  }
  return identifiers;
}
function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);
  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }
      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };
  return updater;
}
module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];
    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }
    var newLastIdentifiers = modulesToDom(newList, options);
    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];
      var _index = getIndexByIdentifier(_identifier);
      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();
        stylesInDOM.splice(_index, 1);
      }
    }
    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 90569:
/***/ ((module) => {

"use strict";


var memo = {};

/* istanbul ignore next  */
function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target);

    // Special case to return head of iframe instead of iframe itself
    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }
    memo[target] = styleTarget;
  }
  return memo[target];
}

/* istanbul ignore next  */
function insertBySelector(insert, style) {
  var target = getTarget(insert);
  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }
  target.appendChild(style);
}
module.exports = insertBySelector;

/***/ }),

/***/ 19216:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}
module.exports = insertStyleElement;

/***/ }),

/***/ 3565:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;
  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}
module.exports = setAttributesWithoutAttributes;

/***/ }),

/***/ 7795:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";
  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }
  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }
  var needLayer = typeof obj.layer !== "undefined";
  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }
  css += obj.css;
  if (needLayer) {
    css += "}";
  }
  if (obj.media) {
    css += "}";
  }
  if (obj.supports) {
    css += "}";
  }
  var sourceMap = obj.sourceMap;
  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  }

  // For old IE
  /* istanbul ignore if  */
  options.styleTagTransform(css, styleElement, options.options);
}
function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }
  styleElement.parentNode.removeChild(styleElement);
}

/* istanbul ignore next  */
function domAPI(options) {
  if (typeof document === "undefined") {
    return {
      update: function update() {},
      remove: function remove() {}
    };
  }
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}
module.exports = domAPI;

/***/ }),

/***/ 44589:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }
    styleElement.appendChild(document.createTextNode(css));
  }
}
module.exports = styleTagTransform;

/***/ }),

/***/ 68779:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 38213:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 97880:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 98060:
/***/ ((module) => {

"use strict";
module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 580:
/***/ ((module) => {

"use strict";
module.exports = require("prop-types");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 78815:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__78815__;

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__(79461));
/******/ return __webpack_exports__;
/******/ }
]);
});